<template>
    <div class="layersContainer">
        <template v-if="mapLayer.isGroup">
            <!-- can add a toggle to using a high vs low res version of the map with a v-if template here -->
            <!-- <template v-if="highResImagery"> etc -->
            <template v-if="!showHighResImagery">
                <GoogleMapStaticLayer
                    v-for="layer in mapLayer.layers"
                    :key="`staticMapLayer-${layer.mapid}-${mapLayer.mapLayerID}`"
                    :google="google"
                    :map="map"
                    :layer-data="layer"
                    :layerID="mapLayer.mapLayerID"
                    :maxOpacity="mapLayer.maxOpacity"
                    :bbox="mapLayer.bbox"
                    @loading-map-url="$emit('loading-map-url')"
                    @map-url-loaded="$emit('map-url-loaded')"
                    />
            </template>
            <template v-else>
                <GoogleMapLayer
                    v-for="layer in mapLayer.layers"
                    :key="`mapLayer-${layer.mapid}-${mapLayer.mapLayerID}`"
                    :google="google"
                    :map="map"
                    :layer-data="layer"
                    :layerID="mapLayer.mapLayerID"
                    :maxOpacity="mapLayer.maxOpacity"
                    :isGroup=true
                    :isMapMoving="isMapMoving"
                    @tiles-loading="(value) => $emit('tiles-loading', value)"
                    />
            </template>
        </template>
        <template v-else>
            <GoogleMapLayer
                :key="`mapLayer-${mapLayer.layers[0].mapid}-${mapLayer.mapLayerID}`"
                :google="google"
                :map="map"
                :layer-data="mapLayer.layers[0]"
                :layerID="mapLayer.mapLayerID"
                :isGroup=false
                @tiles-loading="(value) => $emit('tiles-loading', value)"
                />
        </template>
            
    </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import GoogleMapLayer from "@/components/ResultMap/GoogleMapLayer";
import GoogleMapStaticLayer from "@/components/ResultMap/GoogleMapStaticLayer";

export default {
    name: "GoogleMapLayerContainer",
    components: {
        GoogleMapLayer,
        GoogleMapStaticLayer
    },
    props: {
        google: {
            type: Object,
            required: true
        },
        map: {
            type: Object,
            required: true
        },
        mapLayer: {
            type: Object,
            required: true
        },
        showHighResImagery: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            isMapMoving: false
        }
    },
    watch: {
        selectedLayer: {
            immediate: true,
            handler(selectedLayer) {
                if (this.mapLayer.layers){
                    this.mapLayer.layers.forEach((layer, index) => {
                    if (index == selectedLayer){
                        layer.displayLayer = true;
                    } else {
                        layer.displayLayer = false;
                    }
                    });
                }
            }
        },
    },
    mounted() {
        // adds event listeners for when the map is moving
        this.zoom = this.map.getZoom();
        this.map.addListener('zoom_changed', () => {
            let currentZoom = this.map.getZoom()
            if(this.zoom !== currentZoom) {
                this.isMapMoving = true;
                this.zoom = currentZoom
            }
        })
        this.map.addListener('drag', () => {
            this.isMapMoving = true;
        })
        this.map.addListener('idle', () => {
            this.isMapMoving = false;
        })
    },
    computed: {
        selectedLayer() {
            return this.mapLayer.selectedLayer;
        }
    },
}
</script>

<style scoped>
.layersContainer {
    display: none;
}
</style>